import useSWR, { KeyedMutator, mutate } from 'swr';
import { ReviewStatsResponse } from '~/types/question-review';

type SWRResponse = {
  reviewStats: ReviewStatsResponse;
  mutateReviewStats: KeyedMutator<any>;
};

const getUrl = (dealId: number) => `/api/v2/deals/${dealId}/review_stats/`;

export function useReviewStats(dealId: number): SWRResponse {
  const { data: reviewStats, mutate: mutateReviewStats } = useSWR(
    getUrl(dealId),
  );

  return { reviewStats, mutateReviewStats };
}

export function mutateReviewStats(dealId: number) {
  return mutate(getUrl(dealId));
}
